import { BookingDetailModel, BookingStatus } from '../../models/view-schedule/booking-detail.model';
import { Injectable } from '@angular/core';
import { BaseService } from '../../shared/services/base.service';
import { Utility } from '../../common/utility';
import { RequestAppointmentUrl } from '../../shared/urls/request-appointment.url';
// import { BookingUrl } from '../../../shared/urls/booking.url';

@Injectable( )
export class BookingDetailService {
    constructor (
            public baseService: BaseService) { }
    getBookingDetail(id) {
        const url = RequestAppointmentUrl.BOOKING_DETAIL.replace('{id}', id);
        return this.baseService.getData(url);
    }
    // getDataStatus() {
    //     const url = BookingUrl.GET_ALL_STATUS;
    //     return this.baseService.getAll(url);
    // }
    removeBooking(id) {
        const url = RequestAppointmentUrl.DELETE_BOOKING.replace('{id}',id);
        return this.baseService.delete(url);
    }
    // getDataclinicType() {
    //     const url = BookingUrl.GET_CLINIC_TYPE;
    //     return this.baseService.getAll(url);
    // }
    getDataRow() {
        return dataRow;
    }
    // savingBookingDetail(id, param){
    //     const url = BookingUrl.SAVING_BOOKING_DETAIL + `${id}`;
    //     return this.baseService.put(url, param);
    // }

    // confirmBookingDetail(id, param){
    //     const url = BookingUrl.CONFIRM_BOOKING_DETAIL + `${id}`;
    //     return this.baseService.put(url, param);
    // }
}

export const statusBooking = [
    {
        id: 1,
        name: 'NewBooking',
    },
    {
        id: 2,
        name: 'Confirmed',
    },
    {
        id: 3,
        name: 'Arrived',
    },
    {
        id: 4,
        name: 'DNA (Do not arrive)',
    },
    {
        id: 5,
        name: 'Cancelled',
    }
];

export const clinicType = [
    {
        id: 1,
        name: 'Data Entry',
    },
    {
        id: 2,
        name: 'Flu Vaccine',
    },
    {
        id: 3,
        name: 'Follow up Screening',
    },
    {
        id: 4,
        name: 'Return Nurse',
    },
    {
        id: 5,
        name: 'Screening Clinic',
    },
    {
        id: 6,
        name: 'Travel Vaccinations',
    },
    {
        id: 7,
        name: 'TVAC 2nd Room',
    }

];
export const dataRow = [
    {
        id: '1',
        name: 'Hung Vuong',
        dateOfBirth: '2017-09-10T17:00:00',
        address: '10/5 D2 street HCMC',
        phone: '123456789',
        email: 'abc@mail.com'
    },
    {
        id: '2',
        name: 'Hung Vuong',
        dateOfBirth: '2017-09-10T17:00:00',
        address: '10/5 D2 street HCMC',
        phone: '123456789',
        email: 'abc@mail.com'
    },
    {
        id: '3',
        name: 'Hung Vuong',
        dateOfBirth: '2017-09-10T17:00:00',
        address: '10/5 D2 street HCMC',
        phone: '123456789',
        email: 'abc@mail.com'
    },
];



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/view-schedule/booking-detail.service.ts